export default __webpack_public_path__ + "static/media/question.ee2932fa.svg";